function Hero() {
  return (
    <section className="relative overflow-hidden bg-foreground-950 text-background-50">
      {/* bg art */}
      <div
        className="dot-grid absolute inset-0 opacity-60"
        aria-hidden="true"
      ></div>
      <div
        className="absolute -right-24 -top-24 h-80 w-80 rounded-full bg-primary-600/30 blur-3xl"
        aria-hidden="true"
      ></div>
      <div
        className="absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-accent-600/20 blur-3xl"
        aria-hidden="true"
      ></div>

      <div className="relative mx-auto w-full max-w-[1280px] px-4 pb-14 pt-28 md:px-6 md:pt-36 md:pb-20">
        <div className="flex flex-col items-start gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/10 px-3 py-1 text-xs font-semibold text-background-50 ring-1 ring-background-50/20">
              <i className="ri-sparkling-2-fill text-secondary-300"></i>
              域名迁移追踪 · 发布历史归档
            </span>
            <h1 className="mt-5 font-heading text-3xl font-bold leading-tight tracking-tight md:text-5xl">
              吃瓜地址历史版本与
              <span className="text-secondary-300">换新地址</span>
              <br />
              一站式回溯入口
            </h1>
            <p className="mt-5 max-w-xl text-sm leading-7 text-foreground-200 md:text-base md:leading-8">
              汇总吃瓜地址域名迁移全过程与旧网址去向，实时更新最新可用入口。
              想查往期入口、确认旧网址是否失效，还是第一时间拿到换新地址，
              从这里出发最稳妥。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#current"
                className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-center text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-road-map-fill mr-1.5"></i>前往当前入口
              </a>
              <a
                href="#archive"
                className="flex items-center justify-center whitespace-nowrap rounded-md bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 ring-1 ring-background-50/25 transition-colors hover:bg-background-50/20"
              >
                <i className="ri-history-line mr-1.5"></i>查看历史版本
              </a>
            </div>
          </div>

          {/* status snapshot card */}
          <div className="w-full shrink-0 rounded-2xl bg-background-50/95 p-5 text-foreground-950 shadow-none md:w-[300px]">
            <div className="flex items-center justify-between">
              <span className="text-xs font-semibold uppercase tracking-wider text-foreground-500">
                当前状态
              </span>
              <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-semibold text-accent-800">
                <span className="h-1.5 w-1.5 animate-pulseSoft rounded-full bg-accent-600"></span>
                运行中
              </span>
            </div>
            <p className="mt-4 font-heading text-2xl font-bold">V9.0 · 最新换新地址</p>
            <p className="mt-1 font-heading text-xl font-semibold text-primary-600">cgdz-vip.top</p>
            <div className="mt-4 space-y-2 text-xs text-foreground-600">
              <div className="flex items-center justify-between">
                <span>最近迁移</span>
                <span className="font-medium text-foreground-800">2026-08-30</span>
              </div>
              <div className="flex items-center justify-between">
                <span>备用通道</span>
                <span className="font-medium text-foreground-800">2 条在线</span>
              </div>
              <div className="flex items-center justify-between">
                <span>归档版本</span>
                <span className="font-medium text-foreground-800">9 个</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;